import {transaction} from './transactionDef'
import {basic} from 'basic'
import {tree} from '../genealogy'
import {showError,backEndGeneo} from 'tree/treeProvider'
import React,{useState,useContext,useEffect} from 'react'
import { useParams } from "react-router-dom";
import Text from 'text/text'
import {Langue} from '../context'
import { useNavigate,useLocation } from "react-router-dom";

function Transaction(props:transaction.props)
{
    const [className,style]=basic.getBasic(props)
    const { transaction } = useParams<{ transaction: string }>();
    const backEnd=useContext(backEndGeneo)
    const [validated,setValidated]=useState(false)
    const [done,setDone]=useState(false)
    const [processing,setProcessing]=useState("")
    const [waiting,setWaiting]=useState(true)
    const [erreur,setErreur]=useState<null|string>(null)

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const language = params.get("langue");
    const [langue, setLng] = useState(language && language.toLocaleLowerCase()=="en"?"EN":"FR");
    const [prix,setPrix]=useState(10000)

    async function checkTransaction(transaction:string)
    {
        try{
            
            const res = await fetch(backEnd+"geneo/transaction/"+transaction);
            
            if (!res.ok) {
                debugger
                setErreur("erreur")
                return
               // throw new Error("Failed to load config");
            }
            
            const { status,validated,done,processing,prix }= await res.json();
            if(status!="OK")
                throw status
            setValidated(validated)
            setDone(done)
            setProcessing(processing)
            setWaiting(false)
            setErreur(null)
            setPrix(prix)
            
        }catch(error)
        {
            console.log(error)
            debugger;
           
        }
    }

    useEffect(function(){
        if(!transaction)
            return
        checkTransaction(transaction)
    },[])

    return  <Langue.Provider value={langue}>
            <div className={`${className} gtransaction`} style={{...style}}>
            {
                erreur?
                <div className="gerreur">
                    {erreur}
                </div>:
                <>
                    {
                        done?<Text fr={["Votre généalogie est terminée. Vous devriez la recevoir sous peu"]}
                                   en={["Your genealogy is done. You should receive it soon"]} />:
                        <>
                            {
                                !validated?
                                <Text fr={[`Nous validons si nous sommes en mesure de faire votre généalogie et
                                nous allons vous écrire pour vous dire si nous pouvons la faire ou non`]}
                                      en={["We are validating if we can do the genealogy and we'll keep you informed through email"]}/>:
                                <>
                                    {
                                        processing=="created"?
                                        <div>
                                            <Text fr={[`Le prix est `]} 
                                                  en={[`The cost is `]}/>{prix}$
                                            <br/>
                                            <Text fr={["Vous pouvez faire votre paiement en entrant le numéro de transaction ",
                                                       " dans la section message du virement interac fait à l'adresse metissegaspesie4825@gmail.com "]}
                                                  en={["You can pay by interac eTransfert to metissegaspesie4825@gmail.com. We need you to enter "," in the message field when you fill the interac's form"]}>
                                                    <b>{transaction}</b>
                                            </Text>
                                        </div>:
                                        <div>
                                            <Text fr={[`Votre généalogie est en cours`]} 
                                                  en={[`We are making your genealogy`]} />
                                        </div>
                                    }
                                </>
                            }
                        </>
                    }
                </>
            }
            
                
           </div>
           </Langue.Provider>
}

export default React.memo(Transaction)